import { render, staticRenderFns } from "./setTemplate.vue?vue&type=template&id=68b8bec6&scoped=true"
import script from "./setTemplate.vue?vue&type=script&lang=js"
export * from "./setTemplate.vue?vue&type=script&lang=js"
import style0 from "./setTemplate.vue?vue&type=style&index=0&id=68b8bec6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b8bec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68b8bec6')) {
      api.createRecord('68b8bec6', component.options)
    } else {
      api.reload('68b8bec6', component.options)
    }
    module.hot.accept("./setTemplate.vue?vue&type=template&id=68b8bec6&scoped=true", function () {
      api.rerender('68b8bec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/assessment/components/setTemplate.vue"
export default component.exports